
import { Flex } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import Banner from 'views/admin/main/ecommerce/overviewProduct/components/Banner';

import SearchTableOrders from 'views/admin/main/ERP/Personal/RegistroPersonal/components/SearchTableOrders';

export default function SearchUser() {
	type RowObj = {
		Nombre: string;
		id: number;
		fechahora: string;
		updatedAt: string;
		Mesa: number;
		meserosId: number;
		Empresaid: number;
		PrecioTotal: string;
		createdAt: string;
		Estatus: boolean;
	};

	const location = useLocation();
	const url = process.env.REACT_APP_URL_SERVER+"/personal";
	const [data, setData] = useState([]);
	const [isLoading, setisLoading] = useState(true);

	const fetchData = useCallback(async () => {
		setisLoading(true);
		try {
			const response = await fetch(url, { credentials: 'include' });
			const result = await response.json();
			const xD: RowObj[] = result;
			setData(xD);
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setisLoading(false);
		}
	}, [url]);

	useEffect(() => {
		fetchData();
	}, [fetchData, location.pathname]);

	return (
		<Flex direction='column' pt={{ sm: '125px', lg: '75px' }}>
			<Banner />

			<Card px='0px'>

				{
					!isLoading &&

					<SearchTableOrders tableData={data} />
				}

			</Card>
		</Flex>
	);
}
